"use client"

import { useEffect, useRef } from "react"

import { useIntersection } from "@lib/hooks/use-in-view"
import ProductPreviewTemplate from "@modules/products/components/ProductPreviewTemplate"
import { ThumbnailSize } from "@modules/products/components/thumbnail"

type ProductPreviewTemplateWrapperProps = {
  title: string
  thumbnail: string
  thumbnailSize?: ThumbnailSize
  href?: string
  percentageDiscount?: number
  isFeatured?: boolean
  hasFreeShipping?: boolean
  originalPrice?: string
  calculatedPrice?: string
  pagosPrice?: number
  onClick?: () => void
  rating: {
    count_responses: number
    average_rating: number
  } | null
  onInView?: () => void
}

export default function ProductPreviewTemplateWrapper({
  title,
  href = "/",
  thumbnail,
  thumbnailSize = "full",
  isFeatured,
  percentageDiscount,
  hasFreeShipping,
  originalPrice,
  calculatedPrice,
  pagosPrice,
  rating,
  onClick,
  onInView,
}: ProductPreviewTemplateWrapperProps) {
  const ref = useRef<HTMLDivElement>(null)
  const inView = useIntersection(ref, "0px", 0.75, 1000)

  useEffect(() => {
    if (inView && onInView) {
      onInView()
    }
  }, [inView, onInView])

  return (
    <div ref={ref}>
      <ProductPreviewTemplate
        title={title}
        href={href}
        thumbnail={thumbnail}
        thumbnailSize={thumbnailSize}
        isFeatured={isFeatured}
        percentageDiscount={percentageDiscount}
        hasFreeShipping={hasFreeShipping}
        originalPrice={originalPrice}
        calculatedPrice={calculatedPrice}
        pagosPrice={pagosPrice}
        rating={rating}
        onClick={onClick}
      />
    </div>
  )
}
